
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#E8EDFF"}}),_c('path',{attrs:{"d":"M6.875 7.8c.207 0 .375-.18.375-.4 0-.22-.168-.4-.375-.4s-.375.18-.375.4c0 .22.168.4.375.4zM7.625 7.4c0-.22.168-.4.375-.4h1.125c.207 0 .375.18.375.4 0 .22-.168.4-.375.4H8c-.207 0-.375-.18-.375-.4zM8 8.2c-.207 0-.375.18-.375.4 0 .22.168.4.375.4h1.125c.207 0 .375-.18.375-.4 0-.22-.168-.4-.375-.4H8zM8 9.4c-.207 0-.375.18-.375.4 0 .22.168.4.375.4h1.125c.207 0 .375-.18.375-.4 0-.22-.168-.4-.375-.4H8zM7.25 8.6c0 .22-.168.4-.375.4S6.5 8.82 6.5 8.6c0-.22.168-.4.375-.4s.375.18.375.4zM6.875 10.2c.207 0 .375-.18.375-.4 0-.22-.168-.4-.375-.4s-.375.18-.375.4c0 .22.168.4.375.4z","fill":"#668BFF"}}),_c('path',{attrs:{"d":"M6.875 4c-.207 0-.375.18-.375.4h-.75c-.414 0-.75.358-.75.8v6c0 .442.336.8.75.8h4.5c.414 0 .75-.358.75-.8v-6c0-.442-.336-.8-.75-.8H9.5c0-.22-.168-.4-.375-.4h-2.25zM9.5 5.2h.75v6h-4.5v-6h.75v.4c0 .22.168.4.375.4h2.25c.207 0 .375-.18.375-.4v-.4zm-2.25 0v-.4h1.5v.4h-1.5z","fill":"#668BFF"}})])
          )
        }
      }
    